const CONTAINER_ID = 'entrybot-widget-container';

export function hideWidget(): void {
  const el = document.getElementById(CONTAINER_ID);
  if (el) el.style.display = 'none';
}

export function showWidget(): void {
  const el = document.getElementById(CONTAINER_ID);
  if (el) el.style.display = '';
}
